module.exports = __webpack_public_path__ + "img/sweden-genitourinary-diseases-male.b52b4726.png";